<template>
  <div class="aside">
    <div class="theme-main-box">
      <ul class="main-navigation">
        <li class="com_data" @click="refresh">
          <i class="iconfont icon-shuaxin"></i>
          <span class="refresh">刷新</span>
        </li>
        <li :class="$store.getters.viewStatus == 'now' ? 'com_active' : 'com_data'" @click="now">
          <i class="iconfont icon-shishishuju"></i>
          <span>实时数据</span>
        </li>
        <li :class="$store.getters.viewStatus == 'history' ? 'com_active' : 'com_data'" @click="history">
          <i class="iconfont icon-lishishuju"></i>
          <span>历史数据</span>
        </li>
        <li :class="$store.getters.viewStatus == 'alarm' ? 'com_active' : 'com_data'" @click="alarm">
          <i class="iconfont icon-baojingrizhi"></i>
          <span>报警日志</span>
        </li>
        <li :class="$store.getters.viewStatus == 'weekly' ? 'com_active' : 'com_data'" @click="weekly">
          <i class="iconfont icon-baojingrizhi"></i>
          <span>周报统计</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "RightNavigation",
  data () {
    return {
    }
  },
  methods: {
    refresh() {
      // this.$router.go(0)
      this.$http.post('http://wisdom.consec.top:7001/control/get', {
        deviceId: this.$router.currentRoute.params.deviceId
      }).then(res => {
        this.$s('获取当前数据成功！');
        this.getDeviceDetail();
        this.getEchart();
      }).catch(err => {
        // this.$message({type: 'error', code: 0, message: "更新失败"});
        // this.$message({type: 'error', code: 2, message: "设备不在线"});
      })
    },
    now() {
      this.$store.commit("VIEW_STATUS", 'now')
      console.log("this.$store.getters.viewStatus")
      console.log(this.$store.getters.viewStatus)
      console.log("this.$router.currentRoute.params.deviceType")
      console.log(this.$router.currentRoute.params.deviceType)
      console.log("this.$device.cbType.deviceType")
      console.log(this.$device.cbType.deviceType)
      console.log(this.$device.cbType.deviceRoute)
      console.log(this.$device.fireType.deviceRoute)
      console.log("this.$router.currentRoute.params.deviceType")
      console.log(this.$router.currentRoute.params.deviceType)
      console.log(this.$device.cbType.deviceType)
      switch (Number(this.$router.currentRoute.params.deviceType)) {
        case this.$device.fireType.deviceType:
          this.$router.push({
            name: this.$device.fireType.deviceRoute,
          })
          break
        case this.$device.cbType.deviceType:
          this.$router.push({
            name: this.$device.cbType.deviceRoute,
          })
          break
        default:
          console.error("错误设备类型:{}", this.$router.currentRoute.params.deviceType)
      }
    },
    history() {
      this.$store.commit("VIEW_STATUS", 'history')
      console.log("this.$store.getters.viewStatus")
      console.log(this.$store.getters.viewStatus)
      console.log("this.$router.currentRoute.params.deviceType")
      console.log(this.$router.currentRoute.params.deviceType)
      console.log("this.$device.cbType.deviceType")
      console.log(this.$device.cbType.deviceType)
      console.log(this.$device.cbType.deviceRoute)
      console.log(this.$device.fireType.deviceRoute)
      console.log("this.$router.currentRoute.params.deviceType")
      console.log(this.$router.currentRoute.params.deviceType)
      console.log(this.$device.cbType.deviceType)
      switch (Number(this.$router.currentRoute.params.deviceType)) {
        case this.$device.fireType.deviceType:
          this.$router.push({
            name: this.$device.fireType.historyRoute,
          })
          break
        case this.$device.cbType.deviceType:
          this.$router.push({
            name: this.$device.cbType.historyRoute,
          })
          break
        default:
          console.error("错误设备类型:{}", this.$router.currentRoute.params.deviceType)
      }
    },
    alarm() {
      console.log("alarmalarm")
      this.$store.commit("VIEW_STATUS", 'alarm')
      switch (Number(this.$router.currentRoute.params.deviceType)) {
        case this.$device.fireType.deviceType:
          this.$router.push({
            name: this.$device.fireType.alarmRoute,
          })
          break
        case this.$device.cbType.deviceType:
          this.$router.push({
            name: this.$device.cbType.alarmRoute,
          })
          break
        default:
          console.error("错误设备类型:{}", this.$router.currentRoute.params.deviceType)
      }
      // console.log(this.$store.getters.viewStatus)
      // this.$router.push({
      //   name: 'alarm',
      // })
    },
    weekly() {
      console.log("weekly")
      this.$store.commit("VIEW_STATUS", 'weekly')
      this.$router.push({
        name: 'weekly',
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/navigation/RightNavigation.vue